<template>
  <div :class="[`col-lg-${span}`]">
    <label>{{ label }}</label>
    <select
      :id="selectId"
      class="js-select2-custom custom-select"
      size="1"
      style="opacity: 0"
      :disabled="disabled"
      multiple
      data-hs-select2-options='{
          "minimumResultsForSearch": "Infinity"
        }'
    >
      <option v-for="(option, i) in options" :key="`${fieldKey}-select-${i}`" :value="i">{{ option }}</option>
    </select>
  </div>
</template>

<script>
import uniqid from "uniqid";

export default {
  props: ["value", "fieldKey", "label", "options", "span", "nullable", "disabled"],

  data() {
    return {
      uniqid: null,
    };
  },

  mounted() {
    this.initSelect2();
    $(`#${this.selectId}`).val(this.value).trigger("change");
  },

  watch: {
    value(v) {
      $(`#${this.selectId}`).val(v).trigger("change");
    },
  },

  computed: {
    selectId() {
      if (this.uniqid == null) this.uniqid = uniqid();
      return `select-${this.fieldKey}-${this.uniqid}`;
    },
  },

  methods: {
    initSelect2() {
      const select2 = $(`#${this.selectId}`);
      $.HSCore.components.HSSelect2.init(select2);
      select2.on("select2:select", this.handleChange);
      select2.on("select2:unselect", this.handleChange);
    },

    handleChange() {
      const self = this;
      const select2 = $(`#${this.selectId}`);
      var data = select2.select2("data");
      data = data.map((d) => d.id);
      self.$emit("input", data);
    },
  },
};
</script>
